export const defaultBillingIntervalOptions = [
  { label: 'Annual', value: 'Annual' },
  { label: 'Half-Yearly', value: 'Half-Yearly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
];
